import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentRedirect: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    // Get all query parameters
    const payment = searchParams.get('payment');
    const requestId = searchParams.get('request_id');
    
    // Build new URL with parameters
    let newUrl = '/client/billing?tab=payments';
    if (payment) {
      newUrl += `&payment=${payment}`;
    }
    if (requestId) {
      newUrl += `&request_id=${requestId}`;
    }
    
    // Redirect to the new URL
    navigate(newUrl, { replace: true });
  }, [navigate, searchParams]);
  
  return null;
};

export default PaymentRedirect;